<template>
  <div>
    <XsAccountNav v-if="!$route.hash && $vuetify.breakpoint.xsOnly" />
    <div v-else>
      <!-- separate component canidate?-->
      <RouteBack
        v-if="$vuetify.breakpoint.xsOnly"
        class="background-color-white pl-6 pt-3"
        :textContent="'Account'"
      />
      <div
        v-if="$route.hash !== '#about' && $vuetify.breakpoint.xsOnly"
        class="background-color-white mb-3 pl-6 py-2"
      >
        {{ getTitle() }}
      </div>
      <!-- ^^^ separate component canidate? ^^^ -->
      <Title
        v-if="$route.hash !== '#about' && $vuetify.breakpoint.smAndUp"
        :text="getTitle()"
        :src="$route.hash === '#rewards' ? 'crownrewards' : null"
      />
      <MyProfile v-if="$route.hash === '#profile'" />
      <Rewards v-if="$route.hash === '#rewards'" />
      <OrderHistory v-if="$route.hash === '#orders'" />
      <AboutView v-if="$route.hash === '#about'" />
      <SupportContent v-if="$route.hash === '#support'" account />
    </div>
  </div>
</template>

<script>
import AboutView from "@/views/About.vue";
import RouteBack from "@/components/UI/RouteBack.vue";
import MyProfile from "@/components/Account/MyProfile/index.vue";
import Rewards from "@/views/Rewards/index.vue";
import OrderHistory from "@/components/Account/OrderHistory/index.vue";
import SupportContent from "@/components/Support/Content.vue";
import Title from "@/components/UI/Title.vue";
import XsAccountNav from "@/components/Navigation/Xs/Account.vue";

export default {
  name: "AccountView",
  components: {
    AboutView,
    MyProfile,
    Rewards,
    OrderHistory,
    RouteBack,
    SupportContent,
    Title,
    XsAccountNav,
  },
  methods: {
    getTitle() {
      const hashToNavMap = {
        "#orders": "Orders",
        "#profile": "My Profile",
        "#rewards": "Rewards",
        "#about": "About",
        "#support": "Support",
      };
      return hashToNavMap[this.$route.hash] || "My Profile";
    },
  },
};
</script>
